import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  pageContainer: {
    height: '100%',
    overflow: 'auto',
    padding: theme.spacing(2)
  },
  refreshButton: {
    marginBottom: theme.spacing(1),
    justifyContent: 'flex-end'
  }
}));

export default useStyles;
